import BaseModel from '../core/BaseModel'
import WarrantyRepairTypeServiceModel from "./WarrantyRepairTypeServiceModel";
//import CategoriesModel from './CategoriesModel'
export default class ProductExistWarrantyRepairModel extends BaseModel {
    constructor() {
        super({
                name: "product_exist_warranty_repair",
                tableName: 'core_warranty_repair_product_serial_number'
            },
            {
                /*id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },*/
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Mã dịch vụ',
                    width: 8,
                    sortable: false,
                },
                receive_day_reception: {
                    name: 'receive_day_reception',
                    type: "Date",
                    label: 'Ngày tiếp nhận',
                    width: 8,
                    sortable: false
                },
                type_service: {
                    name: 'type_service',
                    type: "Selection",
                    label: 'Loại dịch vụ',
                    class: 'center',
                    dataType: 'Label',
                    width: 8,
                    sortable: false,
                    params: {select: 'code, name', variables: {status: {'_in': [1]}}},
                    models: new WarrantyRepairTypeServiceModel(),
                    // filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'}
                },
                process_status: {//lấy trạng thái sản phẩm gàn tạm
                    name: 'process_status',
                    label: 'Trạng thái',
                    type: "Selection",
                    dataType: 'Label',
                    class: 'center disabled-opacity',
                    width: 8,
                    disabled: true,
                    sortable: false,
                    options: [{ value: 0, label: 'Gửi yêu cầu', style: 'color: #CC0000; font-weight: 500;'}, { value: 1, label: 'Chờ tiếp nhận', style: 'color: #990099; font-weight: 500;'}, { value: 2, label: 'Chờ thực hiện', style: 'color: #0066FF; font-weight: 500;'}, { value: 3, label: 'Chờ giao trả', style: 'color: #FF6600;font-weight: 500;'}, { value: 4, label: 'Hoàn thành', style: 'color: #009900;font-weight: 500;'}],
                   /* filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},*/
                },
                fied_detail: {
                    refs: 'obj_warranty_repair { id code process_status receive_day_reception }',
                    display: false
                },
            },)
    }

}